export default {
  name: 'toggle',

  data () {
    return {
      toggle: false
    }
  },

  methods: {

    didToggleOn() {
      this.toggle = true
    },

    didToggleOff() {
      this.toggle = false
    },

    didToggle() {
      this.toggle = !this.toggle
    }
  },

  render() {
    return this.$scopedSlots.default({
      toggle: this.toggle,
      didToggleOn: this.didToggleOn,
      didToggleOff: this.didToggleOff,
      didToggle: this.didToggle,
    })
  },
}
